import { useEffect } from 'react';

const SITE_BASE = 'https://www.revsvibes.com';
const DEFAULT_OG_IMAGE = 'https://customer-assets.emergentagent.com/job_luxury-motors-13/artifacts/rdqadans_3735.jpg';

/**
 * Sets document title, meta description, Open Graph, Twitter Card, canonical URL, and preview image.
 * Call once at the top of each page component.
 */
export function useDocumentMeta({ title, description, canonical, image }) {
  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const resolvedImage = image
      ? (image.startsWith('http') ? image : `${SITE_BASE}${image}`)
      : DEFAULT_OG_IMAGE;

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Revs Vibes');
    setMeta('property', 'og:image', resolvedImage);
    setMeta('property', 'og:image:width', '1200');
    setMeta('property', 'og:image:height', '630');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', resolvedImage);

    let link = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
  }, [title, description, canonical, image]);
}
